/* Arabic translation layer, ported from the design's runtime i18n.
   English strings in templates are the source of truth; when lang === 'ar'
   the TranslatePipe resolves them through this dictionary (+ dynamic rules). */

export const AR: Record<string, string> = {
  // tabs / common
  'Home': 'الرئيسية', 'Menu': 'منيو', 'Orders': 'الطلبات', 'Account': 'حسابي',
  'Quantity': 'الكمية', 'kg': 'كجم', 'Setting up your order…': 'جارٍ تجهيز طلبك…',
  'Offer': 'عرض', 'Enter offer code': 'أدخل كود العرض', 'Offer applied': 'تم تطبيق العرض',
  'Offer discount': 'خصم العرض', 'Point your camera at the offer QR': 'وجّه الكاميرا إلى رمز العرض',
  'Remove': 'إزالة', 'Cancel': 'إلغاء', 'Scan QR': 'مسح رمز QR', 'This code isn’t valid.': 'هذا الكود غير صالح.',
  'Your offer won’t apply anymore': 'عرضك لن يعود صالحًا', 'Keep offer': 'الاحتفاظ بالعرض',
  'This change means your offer code isn’t valid anymore. Continuing will remove it.': 'هذا التغيير يجعل كود العرض غير صالح. المتابعة ستؤدي إلى إزالته.',
  'Order type unchanged — your offer is still applied.': 'لم يتغيّر نوع الطلب — عرضك ما زال مطبقًا.',
  'Item not added — your offer is still applied.': 'لم تتم إضافة الصنف — عرضك ما زال مطبقًا.',
  'Item not changed — your offer is still applied.': 'لم يتم تعديل الصنف — عرضك ما زال مطبقًا.',
  'Couldn’t update this item': 'تعذر تحديث الصنف',
  'Your offer will be removed': 'سيتم إزالة عرضك',
  'Changing the items in your cart means your offer code no longer applies. Continuing will remove it.': 'تعديل أصناف السلة يعني أن كود العرض لم يعد ساريًا. المتابعة ستؤدي إلى إزالته.',
  'Mark as used address': 'تعيين كعنوان مستخدم',
  'This is your login number — enter a different contact number.': 'هذا رقم تسجيل الدخول — أدخل رقم تواصل مختلفًا.',
  'This phone matches your login number — use a different one.': 'هذا الرقم يطابق رقم تسجيل دخولك — استخدم رقمًا آخر.',
  'Set another address as default first': 'عيّن عنوانًا آخر كافتراضي أولاً',
  'We’ll be right back': 'سنعود قريبًا',
  'This store is temporarily under maintenance. Please check back soon.': 'المتجر تحت الصيانة مؤقتًا. يرجى المحاولة لاحقًا.',
  'Ordering paused': 'الطلب متوقف مؤقتًا', 'We’re taking a short break': 'نأخذ استراحة قصيرة',
  'Online ordering is paused while we make some updates. We’ll be back very shortly — thanks for your patience.': 'الطلب أونلاين متوقف مؤقتًا بينما نجري بعض التحديثات. سنعود قريبًا جدًا — شكرًا لصبرك.',
  'Try again': 'حاول مجددًا', 'Still down? We’ll be back as soon as we can.': 'ما زال متوقفًا؟ سنعود في أقرب وقت ممكن.',
  'Start your order': 'ابدأ طلبك', 'View cart': 'عرض السلة', 'Checkout': 'إتمام الطلب',
  'Add to cart': 'أضف إلى السلة', 'Update item': 'تحديث الصنف', 'Updated': 'تم التحديث', 'Choose options': 'اختر الخيارات', 'Add more items': 'أضف المزيد',
  'Confirm': 'تأكيد', 'Apply': 'تطبيق', 'Sign in': 'تسجيل الدخول', 'Sign out': 'تسجيل الخروج',
  'Clear': 'مسح', 'Reorder': 'اطلب مجددًا', 'Required': 'مطلوب', 'Optional': 'اختياري',
  'Change': 'تغيير', 'Edit': 'تعديل', 'Install': 'تثبيت', 'Popular': 'الأكثر طلبًا',
  'Map': 'الخريطة', 'Nearest': 'الأقرب', 'All offers': 'كل العروض', 'FREE': 'مجاني',
  'Sold out': 'نفد', 'Coming soon': 'قريبًا', 'Completed': 'اكتمل', 'Photo': 'صورة', 'Add photo': 'أضف صورة',
  'items': 'صنف', 'item': 'صنف', 'min': 'دقيقة', 'km': 'كم', 'EGP': 'ج.م', 'ratings': 'تقييم', 'kcal': 'سعرة',

  // fulfillment
  'Delivery to': 'التوصيل إلى', 'Pickup from': 'الاستلام من', 'Dine-in at': 'الطلب في',
  'Delivery': 'توصيل', 'Pickup': 'استلام', 'Dine-in': 'في المطعم',
  'How would you like it?': 'كيف تريد طلبك؟', 'Delivery address': 'عنوان التوصيل',
  'Add new address': 'أضف عنوانًا جديدًا', 'Pickup branch': 'فرع الاستلام', 'Select your branch': 'اختر الفرع',
  'My location': 'موقعي', 'Nasr City': 'مدينة نصر', 'Giza': 'الجيزة',
  'Maadi': 'المعادي', 'Zamalek': 'الزمالك', 'New Cairo': 'القاهرة الجديدة', 'Heliopolis': 'مصر الجديدة',
  'Work': 'العمل', 'Other': 'آخر',
  'Building': 'المبنى', 'Street': 'الشارع', 'Area': 'المنطقة', 'Floor & apartment': 'الدور والشقة', 'Save address': 'حفظ العنوان',
  'Pin your location': 'حدّد موقعك على الخريطة', 'Drag the map or tap to drop the pin at your door.': 'اسحب الخريطة أو انقر لوضع الدبوس عند بابك.',
  'Checking location…': 'جارٍ التحقق من الموقع…', 'Delivers to': 'يوصّل إلى', 'This location is outside our delivery area.': 'هذا الموقع خارج نطاق التوصيل لدينا.',
  'Fill building and street.': 'أدخل المبنى والشارع.', 'Pin your location or pick an area.': 'حدّد موقعك على الخريطة أو اختر منطقة.',
  'Use my current location': 'استخدم موقعي الحالي',
  'Open': 'مفتوح', 'Closed': 'مغلق', 'opens at': 'يفتح الساعة',
  'Choose an order type and a branch to start ordering.': 'اختر نوع الطلب والفرع لبدء الطلب.',
  'Choose your order type to start': 'اختر نوع طلبك للبدء',
  'Cart cleared — branch changed': 'تم تفريغ السلة — تغيّر الفرع',
  'This branch is closed for online ordering right now. Schedule your order or pick another branch.':
    'هذا الفرع مغلق للطلب أونلاين حاليًا. جدوِل طلبك أو اختر فرعًا آخر.',

  // home
  'Meat yourself.': 'دلّع نفسك.', 'Smashed to order.': 'يُحضّر عند الطلب.',
  'Premium cuts ground in-house every morning, smashed on the flat-top and at your door in 45 minutes.':
    'لحوم مختارة تُفرم في مطبخنا كل صباح، تُحضّر على الجريل وتصل إلى بابك خلال 45 دقيقة.',
  'Offers for you': 'عروض لك', 'Order it again': 'اطلبه مجددًا', 'Your usual, one tap away': 'المفضّل لديك بضغطة واحدة',
  'Best sellers': 'الأكثر مبيعًا', "What everyone's ordering": 'ما يطلبه الجميع',
  'Explore the menu': 'تصفّح المنيو', 'Popular right now': 'الأكثر رواجًا الآن',
  'Our story': 'قصتنا', 'From the block to the bun': 'من اللحم الطازج إلى الساندويتش',
  'Find a branch': 'ابحث عن فرع', 'Explore categories': 'تصفّح الفئات', 'Loved by Cairo': 'محبوب في القاهرة',
  'Follow the butchers': 'تابِعنا',
  'Call to order': 'اطلب بالهاتف', 'Scan to dine-in': 'امسح للطلب في المطعم', 'Order by phone': 'اطلب عبر الهاتف',
  'Powered by': 'مدعوم من',
  'Failed': 'فشل', 'Refunded': 'تم الاسترداد', 'Unknown': 'غير معروف',
  'not added to your cart': 'لم يُضف إلى السلة',
  'Rejected': 'مرفوض', 'Awaiting payment': 'في انتظار الدفع', 'Rider': 'المندوب', 'Branch': 'الفرع', 'Payment method': 'طريقة الدفع', 'Discount': 'الخصم', 'Prices include VAT': 'الأسعار شاملة الضريبة', 'Cash': 'نقدًا', 'Card': 'بطاقة', 'Wallet': 'محفظة', 'Kitchen': 'المطبخ',
  'Pre-ordering is optional for dine-in — your food is ready when you arrive.': 'الطلب المسبق اختياري في المطعم — طعامك يكون جاهزًا عند وصولك.', 'Add at least one item to continue.': 'أضف صنفًا واحدًا على الأقل للمتابعة.', 'added': 'مضاف', 'All': 'الكل',
  'Track, pay, edit or cancel your bookings': 'تابع حجوزاتك، ادفع، عدّل أو ألغِ',
  'Upcoming': 'القادمة',
  'Past': 'السابقة',
  'No upcoming reservations': 'لا توجد حجوزات قادمة',
  'No past reservations': 'لا توجد حجوزات سابقة',
  'RESERVATION': 'الحجز',
  'Quote this number when you call the restaurant': 'اذكر هذا الرقم عند الاتصال بالمطعم',
  'Pay to confirm your reservation': 'ادفع لتأكيد حجزك',
  'It expires and the slot is released when the timer ends.': 'ينتهي الحجز ويُلغى الموعد عند انتهاء المؤقت.',
  'Submitted without payment. The restaurant will review and confirm it.': 'تم الإرسال بدون دفع. سيراجع المطعم الحجز ويؤكده.',
  'The deposit wasn’t paid in time, so this reservation expired and the slot was released.': 'لم يُدفع العربون في الوقت المحدد، فانتهى الحجز وأُلغي الموعد.',
  'refunded to your card via Fawry.': 'تم استرداده إلى بطاقتك عبر فوري.',
  'Time slot': 'الموعد',
  'Bill': 'الفاتورة',
  'Paid online': 'مدفوع أونلاين',
  'Pay at the restaurant': 'ادفع في المطعم',
  'Paid in full': 'مدفوع بالكامل',
  'Booked': 'محجوز',
  'Submitted': 'مُرسل',
  'Checked in': 'تم الوصول',
  'No items pre-ordered — you’ll order at the table.': 'لا توجد أصناف مطلوبة مسبقًا — ستطلب على الطاولة.',
  'To cancel, please call the restaurant.': 'للإلغاء، يرجى الاتصال بالمطعم.',
  'Need to change something? Call the restaurant.': 'تريد تعديل شيء؟ اتصل بالمطعم.',
  'Cancel this reservation?': 'إلغاء هذا الحجز؟',
  'Keep it': 'الإبقاء عليه',
  'Nothing has been paid, so there’s no charge. This can’t be undone.': 'لم يُدفع شيء، فلا توجد رسوم. لا يمكن التراجع عن ذلك.',
  'will be refunded to your card through Fawry. This can’t be undone.': 'سيتم استرداده إلى بطاقتك عبر فوري. لا يمكن التراجع عن ذلك.',
  'Reservation cancelled · refund on its way': 'تم إلغاء الحجز · الاسترداد في الطريق',
  'Payment received · reservation confirmed': 'تم استلام الدفع · تم تأكيد الحجز',
  'Reservation not found': 'الحجز غير موجود',
  'Add items': 'أضف أصنافًا',
  'Review & pay': 'المراجعة والدفع',
  'Review changes': 'مراجعة التعديلات',
  'Deposit': 'العربون',
  'No items pre-ordered.': 'لا توجد أصناف مطلوبة مسبقًا.',
  'No items yet.': 'لا توجد أصناف بعد.',
  'Fees and the deposit are calculated at the last step.': 'تُحسب الرسوم والعربون في الخطوة الأخيرة.',
  'a delivery address': 'عنوان توصيل',
  'a branch': 'فرعًا',
  'a time slot': 'موعدًا',
  'a seating zone': 'منطقة جلوس',
  'Choose': 'اختر',
  'and': 'و',
  'to continue': 'للمتابعة',
  'Saved payment methods': 'طرق الدفع المحفوظة', 'Soon you’ll be able to save a card for faster checkout.': 'قريبًا ستتمكن من حفظ بطاقتك لدفع أسرع.', 'All Branches': 'كل الفروع',
  'This branch doesn’t take online orders.': 'هذا الفرع لا يستقبل الطلبات أونلاين.',
  'Store not found': 'المتجر غير موجود', 'We couldn’t find this restaurant': 'لم نتمكن من العثور على هذا المطعم', 'There’s no restaurant at': 'لا يوجد مطعم على', 'Check the address, or ask the restaurant for their ordering link.': 'تأكد من العنوان، أو اطلب رابط الطلب من المطعم.', 'locations': 'فروع', 'location': 'فرع', 'All rights reserved.': 'جميع الحقوق محفوظة.',
  'Order details': 'تفاصيل الطلب', 'Continue browsing': 'متابعة التصفّح',
  'Adding to your home screen…': 'تتم الإضافة إلى شاشتك الرئيسية…',
  'Already added to your home screen.': 'تمت إضافته بالفعل إلى شاشتك الرئيسية.',
  'Tap Share, then “Add to Home Screen”.': 'اضغط على مشاركة، ثم «إضافة إلى الشاشة الرئيسية».',
  'Open the browser menu and choose “Add to Home Screen”.': 'افتح قائمة المتصفح واختر «إضافة إلى الشاشة الرئيسية».',

  // help & support
  'Help & support': 'المساعدة والدعم',
  'Guests can reach us without signing in — no account needed.': 'يمكن للضيوف التواصل معنا دون تسجيل الدخول — لا حاجة إلى حساب.',
  'Reach us': 'تواصل معنا',
  'Call the hotline': 'اتصل بالخط الساخن',
  'WhatsApp us': 'راسِلنا على واتساب',
  'Typically replies in minutes': 'يرد عادةً خلال دقائق',
  'Email': 'البريد الإلكتروني',
  'Legal': 'الأمور القانونية',
  'Terms & conditions': 'الشروط والأحكام',
  'Privacy policy': 'سياسة الخصوصية',

  // menu / search
  'Search burgers, fries, shakes…': 'ابحث عن برجر، بطاطس، ميلك شيك…',
  'Search the menu': 'ابحث في المنيو',
  'Search dishes, drinks, desserts…': 'ابحث عن أطباق، مشروبات، حلويات…', 'Search by tag': 'ابحث حسب الوسم',
  'Results': 'النتائج', 'No results for': 'لا توجد نتائج لـ',
  'Natural search — coming soon.': 'البحث الذكي — قريبًا.',
  'Type things like “something spicy under 150” or “no onions”.': 'اكتب مثل «حاجة حارة أقل من 150» أو «بدون بصل».', 'Recently ordered': 'طلبت مؤخرًا',
  'Start typing to find an item by name.': 'ابدأ الكتابة للعثور على صنف بالاسم.', 'Try another item name.': 'جرّب اسم صنف آخر.',
  'Loading menu…': 'جارٍ تحميل المنيو…', 'Nothing on the menu right now': 'لا يوجد شيء في المنيو حاليًا',
  'This branch isn’t serving online orders at the moment.': 'هذا الفرع لا يستقبل طلبات أونلاين حاليًا.',
  'Recommended for you': 'موصى به لك',

  // item sheet
  'Choose your option': 'اختر الخيار', 
  'Your Choice Of Size': 'اختر الحجم المختار ', 

  'Could not load this item': 'تعذّر تحميل هذا الصنف', 'Loading…': 'جارٍ التحميل…',
  'Choose option': 'اختر الخيار', 'Choose 1': 'اختر 1', 'characters left': 'حرف متبقٍ',
  'add quantities': 'أضف الكميات',
  'Kindly select order type / location first.': 'يرجى اختيار نوع الطلب / الموقع أولاً.',
  'Kindly scan QR table first.': 'يرجى مسح رمز QR الخاص بالطاولة أولاً.',
  'Scan your table QR': 'امسح رمز QR الخاص بطاولتك', 'Scan table QR': 'مسح رمز الطاولة',
  'Table scanned': 'تم مسح الطاولة',
  'Choose your size': 'اختر الحجم', 'Cheese': 'الجبنة', 'Stack it up': 'أضف المكونات',
  'Signature sauce': 'الصوص المميز', 'Anything to remove?': 'هل تريد إزالة شيء؟',
  'Make it a meal': 'اجعلها وجبة', 'Size': 'الحجم', 'Load it up': 'حمّلها بالمكونات',
  'Flavor': 'النكهة', 'Top it': 'الإضافات العلوية', 'Special instructions': 'تعليمات خاصة',
  'e.g. extra crispy, sauce on the side': 'مثال: مقرمش زيادة، الصوص جانبًا',
  'Allergens': 'مسببات الحساسية',
  'Gluten': 'جلوتين', 'Dairy': 'ألبان', 'Egg': 'بيض', 'Sesame': 'سمسم', 'Soy': 'صويا', 'Mushroom': 'مشروم',

  // categories
  'Smash Burgers': 'سماش برجر', 'Chicken': 'دجاج', 'Loaded Fries & Sides': 'بطاطس وأطباق جانبية',
  'Plant-Based': 'نباتي', 'Shakes & Drinks': 'ميلك شيك ومشروبات', 'Desserts': 'حلويات',

  // cart
  'Your cart': 'سلتك', 'Back': 'رجوع', "You've unlocked free delivery!": 'حصلت على توصيل مجاني!',
  'Complete your meal': 'أكمل وجبتك',
  'Promo code': 'كود الخصم', 'Subtotal': 'المجموع الفرعي', 'Delivery fee': 'رسوم التوصيل',
  'Service charge': 'رسوم الخدمة', 'VAT': 'ضريبة القيمة المضافة', 'Minimum order': 'الحد الأدنى للطلب',
  'Some items are unavailable at this branch and won’t be charged.': 'بعض الأصناف غير متوفرة في هذا الفرع ولن تُحتسب.',
  'Unavailable': 'غير متوفر', 'Add something from the menu — your cart is saved to your account.': 'أضف شيئًا من المنيو — سلتك محفوظة في حسابك.',
  'Total': 'الإجمالي', 'Total to pay': 'المبلغ المستحق', 'Your cart is empty': 'سلتك فارغة',
  'Add a smash burger or two — your cart saves automatically, even if you leave.': 'أضف برجر أو اثنين — سلتك تُحفظ تلقائيًا حتى لو غادرت.',
  'Browse the menu': 'تصفّح المنيو', "That code isn't valid": 'هذا الكود غير صالح',

  // checkout
  'When': 'الوقت', 'As soon as possible': 'في أقرب وقت', 'Schedule for later': 'جدولة لاحقًا',
  'Today': 'اليوم', 'Tomorrow': 'غدًا', 'Payment': 'الدفع', 'Apple Pay': 'Apple Pay',
  'Cash on delivery': 'الدفع عند الاستلام', 'Pay the rider': 'ادفع للسائق',
  'Pay & place order': 'ادفع وأكِّد الطلب', 'Place order': 'أكِّد الطلب',
  'No payment methods available': 'لا توجد وسائل دفع متاحة', 'Secure online payment': 'دفع إلكتروني آمن', 'Saved card': 'بطاقة محفوظة',
  'Choose a payment method.': 'اختر وسيلة الدفع.', 'We couldn’t place your order. Please try again.': 'تعذّر تأكيد طلبك. حاول مرة أخرى.',
  'Complete payment': 'أكمل الدفع', 'Open in browser': 'افتح في المتصفح', 'Payment failed — please try again.': 'فشل الدفع — يرجى المحاولة مرة أخرى.',
  'Payment wasn’t completed. Try again or choose another method.': 'لم يكتمل الدفع. حاول مرة أخرى أو اختر وسيلة أخرى.',

  // feedback / rating
  'Rate your order': 'قيّم طلبك', 'How was everything?': 'كيف كانت تجربتك؟', 'How was your order?': 'كيف كان طلبك؟',
  'You rated this order': 'لقد قيّمت هذا الطلب', 'Food quality': 'جودة الطعام', 'Packaging': 'التغليف',
  'What stood out?': 'ما الذي أعجبك؟', 'Add a review': 'أضف مراجعة', 'Tell us more…': 'أخبرنا المزيد…',
  'Submit rating': 'إرسال التقييم', 'Thanks for your feedback!': 'شكرًا لملاحظاتك!', 'This order can’t be rated.': 'لا يمكن تقييم هذا الطلب.',
  'Could not submit your rating.': 'تعذّر إرسال تقييمك.',
  'Delicious': 'لذيذ', 'Hot & fresh': 'ساخن وطازج', 'Great packaging': 'تغليف رائع', 'Fast delivery': 'توصيل سريع',
  'Friendly rider': 'مندوب لطيف', 'Arrived cold': 'وصل باردًا', 'Wrong item': 'صنف خاطئ', 'Missing item': 'صنف ناقص',
  'Bad packaging': 'تغليف سيئ', 'Late delivery': 'توصيل متأخر',
  'Notes': 'ملاحظات', 'For the kitchen': 'للمطبخ', 'For the rider': 'للسائق',
  'Items': 'الأصناف', 'Payment summary': 'ملخص الدفع', 'VAT (14% · included)': 'ضريبة القيمة المضافة (14% · مشمولة)',
  'Placing your order…': 'جارٍ تأكيد طلبك…', 'Delivered to': 'تم التوصيل إلى', 'Picked up from': 'تم الاستلام من',

  // tracking
  'Order received': 'تم استلام الطلب', 'Preparing': 'قيد التحضير', 'Ready': 'جاهز',
  'Ready for pickup': 'جاهز للاستلام', 'Out for delivery': 'في الطريق إليك', 'Delivered': 'تم التوصيل',
  'We’ve got your order': 'استلمنا طلبك',
  'Your order is being prepared': 'يتم تحضير طلبك',
  'Enjoy your meal': 'بالهناء والشفاء', 'Collect at': 'استلم من',
  'Packed and ready to roll': 'جاهز ومعبّأ للانطلاق', 'Your rider is on the way': 'السائق في الطريق',
  'Enjoy! 🔥': '!بالهنا والشفا 🔥', 'Order complete': 'اكتمل الطلب', 'Order again': 'اطلب مجددًا',
  'Back to home': 'العودة للرئيسية',

  // login / register / reset
  'Sign in to continue': 'سجّل الدخول للمتابعة', 'Welcome back': 'أهلًا بعودتك',
  'Mobile number': 'رقم الجوال', 'Send code': 'إرسال الرمز', 'Enter your code': 'أدخل الرمز',
  'Verification code': 'رمز التحقق', 'Confirm code': 'تأكيد الرمز',
  'What’s your name?': 'ما اسمك؟', 'Your name': 'اسمك', 'Continue': 'متابعة',
  'Verifying…': 'جارٍ التحقق…', 'Resend code': 'إعادة إرسال الرمز',
  'Sign in to start your order. Your cart is saved on this device.': 'سجّل الدخول لبدء طلبك. سلتك محفوظة على هذا الجهاز.',
  'Sign in to check out.': 'سجّل الدخول لإتمام الطلب.',
  'Sign in to view your account.': 'سجّل الدخول لعرض حسابك.', 'Sign in to view your orders.': 'سجّل الدخول لعرض طلباتك.',
  // reservations
  'Book ahead': 'احجز مسبقًا',
  'Reserve a table or schedule pickup & delivery': 'احجز طاولة أو حدّد موعد استلام وتوصيل',
  'My reservations': 'حجوزاتي', 'New reservation': 'حجز جديد',
  'Reservation type': 'نوع الحجز', 'Continue to deposit': 'المتابعة للعربون',
  'Guests': 'الضيوف', 'How many guests?': 'كم عدد الضيوف؟', 'Date': 'التاريخ', 'Time': 'الوقت', 'Zone': 'المنطقة',
  'Loading times…': 'جارٍ تحميل الأوقات…', 'Closed on this day — pick another date.': 'مغلق في هذا اليوم — اختر تاريخًا آخر.',
  'No times available for this day.': 'لا توجد أوقات متاحة لهذا اليوم.', 'left': 'متبقٍ',
  'Your items': 'أصنافك', 'Summary': 'الملخص', 'Minimum deposit': 'الحد الأدنى للعربون',
  'Anything the restaurant should know?': 'هل هناك ما يجب أن يعرفه المطعم؟',
  'Pay full total': 'دفع المبلغ كامل', 'Pay minimum deposit': 'دفع الحد الأدنى للعربون', 'Submit without paying': 'إرسال دون دفع',
  'Reservations are not available right now.': 'الحجوزات غير متاحة حاليًا.', 'Reservation submitted': 'تم إرسال الحجز',
  'Reservation': 'الحجز', 'No reservations yet': 'لا توجد حجوزات بعد', 'Type': 'النوع', 'No items': 'لا توجد أصناف',
  'Pay within': 'ادفع خلال', 'to hold this reservation': 'للاحتفاظ بهذا الحجز',
  'Paid': 'المدفوع', 'Remaining balance': 'المبلغ المتبقي', 'Pay now': 'ادفع الآن', 'I’ve paid — refresh': 'لقد دفعت — تحديث',
  'Cancel reservation': 'إلغاء الحجز', 'Edit guests': 'تعديل عدد الضيوف', 'Save': 'حفظ',
  'Reservation updated': 'تم تحديث الحجز', 'Reservation cancelled': 'تم إلغاء الحجز',
  'Kindly call the restaurant for any adjustment.': 'يرجى الاتصال بالمطعم لأي تعديل.',
  'Unpaid': 'غير مدفوع', 'Deposit paid': 'تم دفع العربون', 'Fully paid': 'مدفوع بالكامل',
  'Complete payment in the new tab…': 'أكمل الدفع في التبويب الجديد…', 'Payment received': 'تم استلام الدفع',
  // reservations — booking wizard
  'Make a reservation': 'اعمل حجز', 'Step': 'الخطوة', 'of 3': 'من 3', 'total': 'إجمالي',
  'More': 'المزيد',
  'Deliver to': 'التوصيل إلى', 'Seating zone': 'منطقة الجلوس',
  'guest': 'ضيف', 'guests': 'ضيوف',
  'No items match your search': 'لا توجد أصناف مطابقة لبحثك',
  'Pre-order is optional — you can order at the table.': 'الطلب المسبق اختياري — يمكنك الطلب على الطاولة.',
  'Pick what to prepare for your scheduled time.': 'اختر ما تريد تحضيره في موعدك.',
  'Skip — order at the table': 'تخطَّ — اطلب على الطاولة', 'Review': 'المراجعة',
  'Your reservation': 'حجزك', 'Pre-ordered items': 'الأصناف المطلوبة مسبقًا',
  'Add a note': 'أضف ملاحظة',
  'e.g. Birthday table, high chair needed…': 'مثال: طاولة عيد ميلاد، نحتاج كرسي أطفال…',
  'e.g. Extra napkins, call on arrival…': 'مثال: مناديل إضافية، اتصل عند الوصول…',
  'Required deposit': 'العربون المطلوب',
  'Deducted from your final bill. Refunded if you cancel in time.': 'يُخصم من فاتورتك النهائية. ويُردّ بالكامل إذا ألغيت في الوقت المناسب.',
  'Could not price this reservation.': 'تعذّر تسعير هذا الحجز.',
  'Some items are no longer available and were dropped.': 'بعض الأصناف لم تعد متاحة وتم استبعادها.',
  'Pay deposit': 'ادفع العربون', 'Pay full': 'ادفع كاملًا', 'Confirm reservation': 'تأكيد الحجز',
  'Hold the table for': 'احجز الطاولة لمدة', 'min — pay the deposit later': 'دقيقة — وادفع العربون لاحقًا',
  'Reserve now — pay the deposit later': 'احجز الآن — وادفع العربون لاحقًا',
  'Book a table or schedule a pickup or delivery ahead of time.': 'احجز طاولة أو حدّد موعد استلام أو توصيل مسبقًا.',
  // reservations — editing an existing booking through the same wizard
  // toasts (the toast bar renders through the pipe; interpolated ones are
  // composed at the call site so only the fixed part is looked up)
  'Added': 'أُضيف', 'enjoy!': 'بالهناء والشفاء!',
  'Scan your table QR to continue.': 'امسح رمز QR الخاص بطاولتك للمتابعة.',
  'Preview only — ordering is turned off here.': 'معاينة فقط — الطلب غير متاح هنا.',
  'Thanks for your rating!': 'شكرًا على تقييمك!',
  // orders list / order details / tracking chrome
  'Active': 'نشط', 'Past orders': 'الطلبات السابقة', 'Track live': 'تتبّع مباشر',
  'Order': 'طلب', 'Qty': 'الكمية', 'Paid with': 'تم الدفع بواسطة', 'Total paid': 'إجمالي المدفوع',
  'Rate this order': 'قيّم هذا الطلب',
  'to your door': 'إلى باب منزلك', 'until ready': 'حتى الجهوزية',
  // order statuses as the API returns them (matched case-insensitively)
  'Placed': 'تم الطلب', 'Accepted': 'تم القبول', 'On the way': 'في الطريق',
  'Cancelled': 'ملغي', 'Pending': 'قيد الانتظار',
  // home footer + notifications
  'Follow us': 'تابعنا', 'Notifications': 'الإشعارات', 'You’re all caught up': 'لا جديد لديك',
  'Edit reservation': 'تعديل الحجز', 'Save changes': 'حفظ التغييرات', 'Note': 'ملاحظة',
  'Call the restaurant to change the type, branch or address.': 'اتصل بالمطعم لتغيير النوع أو الفرع أو العنوان.',
  'Updated bill': 'الفاتورة بعد التعديل', 'Already paid': 'المدفوع بالفعل',
  'The restaurant settles any difference when you arrive.': 'يقوم المطعم بتسوية أي فرق عند وصولك.',
  'Could not load this reservation.': 'تعذّر تحميل هذا الحجز.',
  'This reservation can no longer be edited.': 'لم يعد بالإمكان تعديل هذا الحجز.',
  'Could not update.': 'تعذّر التحديث.',
  // account addresses / profile
  'Saved addresses': 'العناوين المحفوظة', 'No saved addresses yet.': 'لا توجد عناوين محفوظة بعد.', 'Default': 'افتراضي',
  'Sign in to add an address': 'سجّل الدخول لإضافة عنوان',
  'Log in or create an account to save a delivery address and start your order.': 'سجّل الدخول أو أنشئ حسابًا لحفظ عنوان التوصيل وبدء طلبك.',
  'Log in or Sign up': 'تسجيل الدخول أو إنشاء حساب',
  'Apartment': 'شقة', 'Villa': 'فيلا', 'Office': 'مكتب', 'Company': 'الشركة', 'Apt. no': 'رقم الشقة', 'Floor number': 'رقم الدور',
  'Profile updated': 'تم تحديث الملف الشخصي', 'Address saved': 'تم حفظ العنوان',
  'Could not update your profile.': 'تعذّر تحديث ملفك الشخصي.', 'Could not save the address.': 'تعذّر حفظ العنوان.',
  'Fill area, building and street.': 'أدخل المنطقة والمبنى والشارع.',
  'Edit address': 'تعديل العنوان', 'Delete': 'حذف', 'Set as default': 'تعيين كافتراضي',
  'Scheduling available': 'الجدولة متاحة', 'Address deleted': 'تم حذف العنوان', 'Could not delete the address': 'تعذّر حذف العنوان',
  'Sign in to add an address.': 'سجّل الدخول لإضافة عنوان.',
  // guests must sign in before choosing an order type / branch
  'Log in to choose your order type': 'سجّل الدخول لاختيار نوع طلبك',
  'Log in to pick a branch': 'سجّل الدخول لاختيار الفرع',
  'Log in to start your order': 'سجّل الدخول لبدء طلبك',
  'Log in to start a table order': 'سجّل الدخول لبدء طلب على الطاولة',
  'Additional details': 'تفاصيل إضافية', 'Contact phone': 'هاتف للتواصل',
  'e.g. near the sporting club gate': 'مثال: بجوار بوابة النادي',
  // address / profile / login form placeholders
  '(optional)': '(اختياري)',
  'e.g. 12B': 'مثال: 12ب', 'e.g. El Tahrir St.': 'مثال: شارع التحرير',
  'e.g. 3': 'مثال: 3', 'e.g. 5': 'مثال: 5', 'e.g. Sonic': 'مثال: سونيك',
  'e.g. Nour Hassan': 'مثال: نور حسن', // the email example needs no translation
  'Sent to': 'أُرسل إلى', 'Enter the password for': 'أدخل كلمة المرور لـ',
  'A number we can call for this address — different from your login number.': 'رقم نتصل به لهذا العنوان — مختلف عن رقم تسجيل دخولك.',
  'We’ll text you a code to verify your number. Your cart is saved.': 'سنرسل لك رمزًا للتحقق من رقمك. سلتك محفوظة.',
  'Password': 'كلمة المرور', 'Your password': 'كلمة المرور', 'New password': 'كلمة المرور الجديدة',
  'Confirm password': 'تأكيد كلمة المرور', 'Forgot password?': 'نسيت كلمة المرور؟',
  'Complete your profile': 'أكمل ملفك الشخصي',
  'Your name for orders, and a password so you can sign in next time.': 'اسمك للطلبات، وكلمة مرور لتسجيل الدخول في المرة القادمة.',
  'Name is required': 'الاسم مطلوب', 'Passwords don’t match': 'كلمتا المرور غير متطابقتين',
  'Repeat the password': 'أعد كتابة كلمة المرور',
  'At least 6 characters': '6 أحرف على الأقل', 'At least 8 characters': '8 أحرف على الأقل',
  'Password must be at least 6 characters': 'كلمة المرور يجب ألا تقل عن 6 أحرف',
  'Password must be at least 8 characters': 'كلمة المرور يجب ألا تقل عن 8 أحرف',
  'Set a new password': 'عيّن كلمة مرور جديدة', 'Save & sign in': 'احفظ وسجّل الدخول',
  'Your number is verified. Choose a new password to sign in with.': 'تم التحقق من رقمك. اختر كلمة مرور جديدة لتسجيل الدخول.',
  'Allow your location': 'اسمح بالوصول لموقعك', 'Allow location access': 'السماح بالوصول للموقع',
  'Locating…': 'جارٍ تحديد الموقع…', 'Start ordering': 'ابدأ الطلب',

  // desktop shell (top bar, footer, menu rail, live cart panel)
  'Pick up at': 'الاستلام من', 'Dine in at': 'الطلب في',
  'Set your address': 'حدد عنوانك', 'Select location': 'اختر الموقع', 'Cart': 'السلة', 'Categories': 'الأقسام',
  'Your order': 'طلبك', 'Book a table': 'احجز طاولة', 'Full menu': 'المنيو الكامل', 'Track an order': 'تتبّع طلبًا',
  'My account': 'حسابي', 'Help': 'المساعدة', 'Branches': 'الفروع', 'Directions': 'الاتجاهات', 'Order here': 'اطلب من هنا',
  'Open now': 'مفتوح الآن', 'No items match': 'لا توجد أصناف تطابق', 'Add': 'أضف', 'Scan to dine in': 'امسح للطلب في المطعم',
  'See all': 'عرض الكل', 'Reserve': 'الحجز', 'Taste the difference': 'جرّب الفرق', 'Back to menu': 'رجوع إلى المنيو',
  'Review your order and choose how to pay': 'راجع طلبك واختر طريقة الدفع', 'Secure checkout': 'دفع آمن',
  'Payments are encrypted and processed securely': 'المدفوعات مشفّرة وتتم معالجتها بأمان',
  'Call': 'اتصال', 'Close': 'إغلاق', 'View receipt': 'عرض الإيصال', 'Delivering to': 'التوصيل إلى', 'Collect from': 'الاستلام من',
  'Prepared by': 'يُحضَّر في', 'Need help?': 'تحتاج مساعدة؟', 'Details': 'التفاصيل', 'Arriving in': 'يصل خلال', 'Ready in': 'جاهز خلال', 'minutes': 'دقيقة',
  'Order summary': 'ملخص الطلب', 'for free delivery': 'للحصول على توصيل مجاني', 'Language': 'اللغة',
  'Add something from the menu and it will show up here.': 'أضف شيئًا من المنيو وسيظهر هنا.',
  'Try a different word, or browse the categories.': 'جرّب كلمة أخرى، أو تصفّح الأقسام.',
  'Our branches': 'فروعنا', 'Selected': 'المحدد', 'No branches available right now.': 'لا توجد فروع متاحة حاليًا.',
  // desktop account
  'Order history': 'سجل الطلبات', 'Manage your orders, addresses and preferences': 'أدر طلباتك وعناوينك وتفضيلاتك',
  'No orders yet': 'لا توجد طلبات بعد', 'View all orders': 'عرض كل الطلبات', 'No saved cards yet.': 'لا توجد بطاقات محفوظة بعد.',
  'Add a new address': 'أضف عنوانًا جديدًا', 'Your account': 'حسابك', 'Hi': 'أهلًا', 'View': 'عرض', 'Edit profile': 'تعديل الملف الشخصي',
  'Preferences': 'التفضيلات', 'Sign in to see your orders': 'سجّل الدخول لعرض طلباتك',
  'Your order history and one-tap reorders live here.': 'سجل طلباتك وإعادة الطلب بضغطة واحدة هنا.',
};

/** Dynamic (interpolated) translation rules. */
export const AR_RULES: Array<[RegExp, (m: RegExpMatchArray) => string]> = [
  [/^Subtotal \((\d+) items?\)$/, (m) => `المجموع الفرعي (${m[1]} صنف)`],
  [/^Estimated delivery in (\d+) min$/, (m) => `التوصيل المتوقع خلال ${m[1]} دقيقة`],
  [/^Estimated ready in (\d+) min$/, (m) => `الجاهزية المتوقعة خلال ${m[1]} دقيقة`],
  [/^(\d+) items?$/, (m) => `${m[1]} صنف`],
  [/^Add (\d[\d,]*) EGP for free delivery$/, (m) => `أضف ${m[1]} ج.م للحصول على توصيل مجاني`],
  [/^(\d+) locations across Cairo$/, (m) => `${m[1]} فروع في أنحاء القاهرة`],
  // option-group rules ("Choose 1 to 3" carries the minimum as well as the cap)
  [/^Choose (\d+) to (\d+)$/, (m) => `اختر من ${m[1]} إلى ${m[2]}`],
  [/^Choose up to (\d+)$/, (m) => `اختر حتى ${m[1]}`],
  [/^Choose (\d+)$/, (m) => `اختر ${m[1]}`],
];
